import { createContext, useContext } from 'react';
import type { Dayjs } from 'dayjs';

/** Rango de fechas [desde, hasta] — ambos null cuando no hay filtro
 * aplicado, o un extremo null cuando el usuario solo fijó uno de los dos. */
export type RangoFecha = [Dayjs | null, Dayjs | null] | null;

export interface FiltroFechaCtx {
  rango:    RangoFecha;
  setRango: (rango: RangoFecha) => void;
}

export const FiltroFechaContext = createContext<FiltroFechaCtx | null>(null);

export function useFiltroFecha(): FiltroFechaCtx {
  const ctx = useContext(FiltroFechaContext);
  if (!ctx) throw new Error('useFiltroFecha debe usarse dentro de <FiltroFechaProvider>');
  return ctx;
}
